import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MaquinaMovil } from "./entity-maquinas-moviles.model";
import { Observable } from "rxjs";
import { environment } from "projects/registro-personas-empresas/src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class MaquinaMovilService {
  endpoint = 'maquinasMoviles';

  constructor(
    private http: HttpClient
  ) { }

  getMaquinasMoviles(): Observable<MaquinaMovil[]> {
    return this.http.get<MaquinaMovil[]>(`${environment.apiUrl}/${this.endpoint}/`);
  }

  addMaquinasMoviles(maquinasMoviles: MaquinaMovil): Observable<MaquinaMovil> {
    return this.http.post<MaquinaMovil>(`${environment.apiUrl}/${this.endpoint}/`, maquinasMoviles);
  }

  deleteMaquinasMoviles(maquinasMoviles: MaquinaMovil): Observable<MaquinaMovil> {
    return this.http.delete<MaquinaMovil>(`${environment.apiUrl}/${this.endpoint}/${maquinasMoviles.id}/`);
  }

  updateMaquinasMoviles(maquinasMoviles: MaquinaMovil): Observable<MaquinaMovil> {
    return this.http.patch<MaquinaMovil>(`${environment.apiUrl}/${this.endpoint}/${maquinasMoviles.id}/`, maquinasMoviles);
  }
}
